import { createContext, useContext, useState } from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { isAdminPortal } from "@/utilities/domain"

const ReportBranchContext = createContext({ branchId: null })

export const useReportBranch = () => useContext(ReportBranchContext)

// The company admin portal lists every branch's records, so each row names
// the branch that owns it.
export const withBranchColumn = (columns) => [
  ...columns,
  {
    header: "Branch",
    id: "branch",
    cell: ({ row }) =>
      row.original.branch_name ?? row.original.branch?.name ?? "—",
  },
]

export const ReportBranchProvider = ({ children }) => {
  const [branchId, setBranchId] = useState(null)

  return (
    <ReportBranchContext.Provider value={{ branchId, setBranchId }}>
      {children}
    </ReportBranchContext.Provider>
  )
}

export const ReportBranchFilter = ({ sx }) => {
  const { branchId, setBranchId } = useReportBranch()
  const { data: branchResponse } = useCustomQuery(
    ["report-branches"],
    "branches/all",
    { enabled: isAdminPortal() }
  )
  const branches = Array.isArray(branchResponse)
    ? branchResponse
    : (branchResponse?.data ?? [])

  if (!isAdminPortal()) {
    return null
  }

  return (
    <FormControl size="small" sx={{ minWidth: 220, mb: 2, ...sx }}>
      <InputLabel id="report-branch-label">Branch</InputLabel>
      <Select
        labelId="report-branch-label"
        label="Branch"
        value={branchId ?? ""}
        onChange={(event) => setBranchId(event.target.value || null)}
      >
        <MenuItem value="">All branches</MenuItem>
        {branches.map((branch) => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.name}
            {branch.code ? ` (${branch.code})` : ""}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
